import { io } from 'socket.io-client';
import { API_CONFIG } from './apiConfig';

const getSocketUrl = () => {
  const baseUrl = API_CONFIG.BASE_URL;
  // Si termina con /api, lo removemos
  if (baseUrl && baseUrl.endsWith('/api')) {
    return baseUrl.slice(0, -4);
  }
  return baseUrl || '/';
};

export const socket = io(getSocketUrl(), {
  autoConnect: true,
  transports: ['websocket', 'polling']
});
